<template>

			<div class="content">
		        <div class="container-fluid">
					<div class="row">
						<div class="col-md-12">
							<div class="nav-bar box-horizontal mb-0">
								<i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
								<div class="flex-1">
									<h3 class="m-0">Tambah Kang Voucher</h3>
								</div>
							</div>
						</div>
					</div>
		        	<div class="row mt-3">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Tambah Kang Voucher</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nama Kang Voucher</label>
                                                <input type="text" class="form-control" placeholder="Nama Kang Voucher..." v-model="nama">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Username <span class="text-info">* Pastikan Username Unik</span></label>
                                                <input type="text" class="form-control" placeholder="Username..." v-model="username">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Password</label>
                                                <input type="text" class="form-control" placeholder="Password..." v-model="password">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Mikrotik</label>
                                                <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="mikrotikPilih">
                                                    <option value="" selected disabled>Pilih Mikrotik</option>
                                                    <option v-for="(u, index) in mikrotik" :value="u.id" >{{u.nama}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="Simpan">Simpan</button>
										<div class="alert alert-info" role="alert" v-show="alert">
											{{alertText}}
										</div>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
				
			<!-- MODAL -->
					<div class="modal" tabindex="-1" role="dialog" v-show="modalArea">
						<div class="overlay"></div>
						<div class="modal-dialog" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Pilih Area</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalArea = false">
									<span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="row">
						<div class="col-md-12">
						<div class="table-responsive" style="height:400px;oveflow:auto">
							<table class="table">
							<thead class=" text-info">
								<th>No.</th>
								<th>Nama</th>
								<th>Jumlah</th>
								<th>Aksi</th>
							</thead>
							<tbody>
								<tr v-for="(u, index) in areaList">
								<td>{{ index+1 }}</td>
								<td>{{ u.nama }}</td>
								<td>{{ u.jumlah }}</td>
								<td>
									<button class="btn btn-sm btn-primary" @click="pilihArea(u.id,u.nama)"> Pilih</button>
								</td>
								</tr>
							</tbody>
							</table>
						</div>
						</div>
									</div>
								</div>
							</div>
						</div>
					</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'
import inter from '@/globalFunc/Interface' 
import router from '@/router'

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
  	data() {
		return {
			title: "Detail Servis",
			nama: '',
			password: '',
			username: '',
			mikrotikPilih: '',
			mikrotik: [],	

			alert: false,
			alertText: "",
		}
	},
	methods: {
		pilihArea(id,nama) {
			var areaInput = this.area;

			if (areaInput.indexOf(nama) === -1) {
				if (areaInput == "") {
					this.area = nama;
					this.areaId = id;
				} else {
					this.area = this.area + ", " + nama;
					this.areaId = this.areaId + "," + id;
				}
			}
		},
		getMikrotik() {
			// for filter
            var data = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
            }
			
			var apiUrl = inter.MiktorikList();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
					this.mikrotik = x.data;
				} else {
					//alert(x.pesan);
				}
			})
		},
        Simpan() {
			if (this.areaId == "") {
				this.alert = true;
				this.alertText = "Area tidak boleh kosong";
				return false;
			}

			this.alert = false;

			var datax = {
				token: 'TangTung '+sessionStorage.getItem('myToken'),
				nama: this.nama,
				mikrotik: this.mikrotikPilih,
				password: this.password,
				username: this.username,
				voucher: "yes"
			}
			
            var apiUrl = inter.AdminTambah();
            
			this.PostData(datax,apiUrl).then(x => {
				//this.loger(x);
				if (x.status) {
				    this.alert = false;
						router.push({ 
							name: 'admin-kangtagih'
						});
				} else {
				    this.alert = true;
				    this.alertText = x.pesan;
				}
			})
        }
	},
	mounted() {
        document.title = "Tambah Admin";

		this.getMikrotik();
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
.modal {
	display: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/kang-voucher/tambah.vue